module.exports = __webpack_public_path__ + "static/school_support_bnM@2x-ae34a6496608432be39306f08a0b9ea5.png";